module Meevo.Plugins.Register {

    class EmailModalController {

        static $inject = [
            "meevo.components.modal.ModalService", "$mdDialog", 'registerContext', 'clientData'
        ];

        constructor(private modalService: Meevo.Components.Modal.IModalService, private $mdDialog, private context: RegisterContext, private clientData:Model.Client) {
            
        }
        
        closeWithAction() {
            this.$mdDialog.hide();
        }
    }

    angular.module("meevo.plugins.register")
        .controller("meevo.plugins.register.EmailModalController", EmailModalController);
}